import {Container} from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import ImageSlider from "../../utils/ImageSlider";

const imageArray = [
    require("../../assets/images/IMG_3682.jpg"),
    require("../../assets/images/IMG_3175.jpg")
];

export function About() {
    return (
        <Container id="about">
            <div className="about-text">
                <ScrollAnimation animateIn="fadeInLeft">
                    <h2><strong>Hello there!</strong></h2>
                    <p>
                        I'm Tilak, a frontend developer
                        specializing in <strong>React.js and Angular</strong>. With
                        expertise in{" "}
                        <strong>
                            JavaScript, TypeScript, and state management tools like Redux
                        </strong>
                        , I build responsive and scalable web applications that deliver
                        seamless user experiences.
                    </p>
                    <p>
                        I am passionate about{" "}
                        <strong>
                            clean coding, performance optimization, and efficient development
                        </strong>
                        . Working in Agile environments, I thrive on collaboration and
                        problem-solving, ensuring that every project meets high standards of
                        quality and usability. Committed to continuous learning, I stay
                        updated with the latest industry trends and technologies to create
                        cutting-edge solutions.
                    </p>
                    <p>
                        If you're looking for a developer to build or enhance your web
                        presence, let's connect and bring your ideas to life! 🚀
                    </p>
                </ScrollAnimation>
            </div>
            <>
                <ScrollAnimation
                    animateIn="fadeInRight"
                    className="about-image flex flex-row-reverse"
                    delay={0.2 * 1000}
                >
                    <ImageSlider images={imageArray} interval={4000}/>
                </ScrollAnimation>
            </>
        </Container>
    );
}
